import React from 'react'
import { Container, Typography, TypographyColorType } from '@cleartrip/ct-design-components'

interface NewFareRulesFeeTxtProps {
    feeName: string
    value: string | number
    valueColor?: TypographyColorType
}

const NewFareRulesFeeTxt: React.FC<NewFareRulesFeeTxtProps> = ({ 
    feeName = '', 
    value = '', 
    valueColor = 'primary' 
}) => {
    return (
        <Container width="208px" className="flex flex-between flex-middle pt-2">
            <Typography variant="B2">{feeName}</Typography>
            <Typography variant="B2" color={valueColor}>
                {value}
            </Typography>
        </Container>
    )
}

export default NewFareRulesFeeTxt
